import React from 'react';
import { Box, Typography, Link } from '@mui/material';

function Footer() {
  return (
    <Box
      component="footer"
      id="footer"
      sx={{
        backgroundColor: '#003E7E',
        color: '#fff',
        textAlign: 'center',
        padding: '1rem'
      }}
    >
      <Typography variant="body2" sx={{ mb: 0.5 }}>
        &copy; 2025 SDSIC
      </Typography>
      <Typography variant="body2">
        <Link
          href="mailto:info@sdsconsortium.com"
          sx={{
            color: '#fff',
            textDecoration: 'none',
            '&:hover': {
              textDecoration: 'underline'
            }
          }}
        >
          info@sdsconsortium.com
        </Link>
      </Typography>
    </Box>
  );
}

export default Footer;
